export const collator = new Intl.Collator('kn', {
        localeMatcher: 'best fit',
        numeric: true,
        caseFirst: 'lower',
    });
